import { combineReducers } from "@reduxjs/toolkit";
import surveySlice from "./surveySlice";
import elementSlice from "./elementSlice";
import elementDataSlice from "./elementDataSlice";
import elementDataCollectionSlice from "./elementDataCollectionSlice";
import elementResourceTransfer from "./elementResourceTransferSlice";
import sectionSlice from "./sectionSlice";

export default combineReducers({
  survey: surveySlice,
  element: elementSlice,
  elementData: elementDataSlice,
  elementDataCollectionSlice: elementDataCollectionSlice,
  elementResourceTransfer: elementResourceTransfer,
  section: sectionSlice,
});
